var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dashboard-items-list',{attrs:{"loading":_vm.$apollo.queries.frecentGroups.loading,"empty-state-text":_vm.s__('Dashboards|Groups you visit often will appear here.'),"group-name":_vm.s__('Dashboards|Frequently visited groups'),"items":_vm.items,"is-group":"","dashboard-name":_vm.dashboardName}})
}
var staticRenderFns = []

export { render, staticRenderFns }